var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"justify-center mb-5"},[_vm._v(_vm._s(_vm.$t('adminVideo.title')))]),_c('v-card-subtitle',{staticClass:"text-center text-secondary"},[_vm._v(_vm._s(_vm.$t('adminVideo.subtitle')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }